import { Component } from '@angular/core';
import { BlockIconText, IconColor, IconType } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';
import { PlIcon } from '@app/icon-library/icons';
import { IconFrame } from '@app/icon-library/lib/pl-icon.component';
import { IconWidth } from '@app/components/iconText/iconText.component';
import { ButtonVariant } from '@app/components/button/button.component';

@Component({
  selector: 'pl-block-icon-text',
  templateUrl: './block-iconText.component.html',
})
export class BlockIconTextComponent extends BlockAbstractComponent<BlockIconText, null> {
  public icon: PlIcon | null = null;
  public iconFrame: IconFrame | null = null;
  public iconWidth: IconWidth | null = null;
  public buttonVariant: ButtonVariant = ButtonVariant.blue;

  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(block: BlockIconText): void {
    this.iconFrame = this.getIconFrame(block.data.icon.type);
    this.icon = this.getIconType(block.data.icon.type);
    this.iconWidth = this.getIconWidth(block.data.icon.type);
    this.buttonVariant = this.getButtonVariant(block.data.button?.color);
  }

  private getIconFrame(iconType: IconType): IconFrame {
    switch (iconType) {
      case IconType.lifeMap:
      case IconType.selfDiscovery:
      case IconType.timeToReflect:
      case IconType.logo:
        return IconFrame.none;
      default:
        return IconFrame.round;
    }
  }

  private getIconWidth(iconType: IconType): IconWidth {
    switch (iconType) {
      case IconType.lifeMap:
        return IconWidth.wider;
      default:
        return IconWidth.normal;
    }
  }

  private getIconType(iconType: IconType): PlIcon {
    switch (iconType) {
      case IconType.chevronBackward:
        return PlIcon.chevron_back;
      case IconType.chevronForward:
        return PlIcon.chevron_forward;
      case IconType.exclamation:
        return PlIcon.exclamation;
      case IconType.eye:
        return PlIcon.eye;
      case IconType.lifeMap:
        return PlIcon.badge_lifemap;
      case IconType.lock:
        return PlIcon.lock;
      case IconType.logo:
        return PlIcon.pl_logo;
      case IconType.pdf:
        return PlIcon.pdf;
      case IconType.selfDiscovery:
        return PlIcon.badge_self_discovery;
      case IconType.strengths:
        return PlIcon.badge_strengths;
      case IconType.tick:
        return PlIcon.tick;
      case IconType.timeToReflect:
        return PlIcon.badge_time_to_reflect;
      default:
        throw new Error(`Unknown icon iconType=${iconType}`);
    }
  }

  private getButtonVariant(buttonColor: IconColor | undefined): ButtonVariant {
    switch (buttonColor) {
      case IconColor.plLogoColor:
        return ButtonVariant.orange;
      case IconColor.primary:
        return ButtonVariant.blue;
      case IconColor.success:
        return ButtonVariant.green;
      case IconColor.alert:
        return ButtonVariant.red;
      default:
        return ButtonVariant.blue;
    }
  }
}
